import React from "react"
import {TextField as PolarisTextField} from "@shopify/polaris"

export default function TextField(props) {

  const {value, ...restProps} = props

  return (
    <PolarisTextField
      value={value === null ? '' : value}
      {...restProps}/>
  )
}